export default __webpack_public_path__ + "static/media/Learning-bro.bbfe6856.svg";